import { AccommodationRoomTypeAttributes } from '@/types'
import { UpdateAccommodationRoomTypeMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'

import { EditAccommodationRoomTypeQuery } from './__generated__/edit_query'
import { Inline as Loading } from '@/components/loading'
import { useEffect, useState } from 'react'
import { Query as TableQuery } from './table_query'
import { Button } from '../base/button'
import { DeleteDialog } from '@/components/delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as EditQuery } from './edit_query'
import { Inline as Error } from '@/components/error'

type Accommodation = EditAccommodationRoomTypeQuery['accommodations']['nodes'][0]

interface Props {
  accommodationId: string
  id: string
  onSuccess: () => void
}

export const Form = ({ accommodationId, id, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdateAccommodationRoomTypeMutation,
    AccommodationRoomTypeAttributes,
    EditAccommodationRoomTypeQuery,
    Accommodation>({
    queryVariables: { accommodationId, accommodationRoomTypeId: id },
    id,
    initializer: accommodation => {
      const accommodationRoomType = accommodation.accommodationRoomTypes.nodes[0]
      return {
        accommodationId,
        name: accommodationRoomType.name,
        notes: accommodationRoomType.notes,
        layout: accommodationRoomType.layout,
        capacity: accommodationRoomType.capacity,
      }
    },
    query: EditQuery,
    queryKey: 'accommodations',
    mutation: UpdateMutation,
    resultKey: 'updateAccommodationRoomType',
    refetchQueries: [TableQuery]
  })

  const [showDelete, setShowDelete] = useState(false)

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  const onDelete = () => {
    setShowDelete(false)
    onSuccess()
  }

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        <div className="grid grid-cols-2 gap-6">
          { formBuilder.buildField({ name: 'Capacity', field: 'capacity', type: 'integer' }) }
          { formBuilder.buildField({ name: 'Layout', field: 'layout', type: 'room-type' }) }
        </div>
        { formBuilder.buildField({ name: 'Notes', field: 'notes', type: 'textarea' }) }
        <div className="flex flex-row justify-between">
          <Button color="red" onClick={() => setShowDelete(true) }>Delete</Button>
          { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
        </div>
        <DeleteDialog
          id={id}
          mutation={DeleteMutation}
          open={showDelete}
          refetchQueries={[TableQuery]}
          setOpen={setShowDelete}
          onSuccess={onDelete}
        />
      </div>
    </>
  )
}
